import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { catelogSubmitData } from "../../store/actions";

const AuctionTable = ({
  auctionDataColumnDetails,
  auctionDataLiveBidDetails,
  handleChange,
  handleButton,
  isHoldAuctionCalled,
  isTimeAvailable,
  activeTab,
  handleSelectRow,
  selectedDataForMyCatalog,
  fetchAuctionCenterDataApiCallResponse,
  countForShowMethod,
  countForShow,
  userCurrentStatus,
  auctionUserId,
  auctionDetailId,
}) => {
  const dispatch = useDispatch();

  let sortedData =
    auctionDataLiveBidDetails != [] && auctionDataColumnDetails != undefined
      ? auctionDataColumnDetails.sort((a, b) => a.sortOrder - b.sortOrder)
      : [];
  const [columns, setColumns] = useState(sortedData);

  useEffect(() => {
    if (true == fetchAuctionCenterDataApiCallResponse) {
      sortedData =
        auctionDataLiveBidDetails != [] && auctionDataColumnDetails != undefined
          ? auctionDataColumnDetails.sort((a, b) => a.sortOrder - b.sortOrder)
          : [];
      setColumns(sortedData);
    }
  });

  useEffect(() => {
    const table = document.getElementById("example");
    const thElements = table.querySelectorAll("th");
    thElements.forEach((th) => {
      const resizeHandle = document.createElement("div");
      resizeHandle.className = "resize-handle";
      th.appendChild(resizeHandle);
      resizeHandle.addEventListener("mousedown", initResize);
    });

    function initResize(e) {
      window.addEventListener("mousemove", resizeColumn);
      window.addEventListener("mouseup", stopResize);
      e.preventDefault();
      const th = e.target.parentElement;
      const startX = e.pageX;
      const startWidth = th.offsetWidth;

      function resizeColumn(e) {
        const newWidth = startWidth + (e.pageX - startX);
        th.style.minWidth = newWidth + "px";
      }

      function stopResize() {
        window.removeEventListener("mousemove", resizeColumn);
        window.removeEventListener("mouseup", stopResize);
      }
    }
  }, []);

  const getRows = (auctionDataLiveBidDetailsData) => {
    let isPeachColorAndBidderNotIn = false;
    if (true == isTimeAvailable) {
      if (0 == auctionDataLiveBidDetailsData.isItemSelected) {
        isPeachColorAndBidderNotIn = true;
      } else {
        isPeachColorAndBidderNotIn = false;
      }
    }
    let selectedRowAvailable = selectedDataForMyCatalog.includes(
      auctionDataLiveBidDetailsData.auctionItemDetailId
    )
      ? true
      : false;

    let maxBidGreaterThanBasePrice = false;

    if (true == isTimeAvailable) {
      if (0 == countForShow) {
        maxBidGreaterThanBasePrice =
          0 == auctionDataLiveBidDetailsData.maxBidGrater ? true : false;
        if (maxBidGreaterThanBasePrice) {
          countForShowMethod();
        }
      } else {
        maxBidGreaterThanBasePrice =
          0 == auctionDataLiveBidDetailsData.maxBidGrater ? true : false;
      }
    }

    const handleInputChange = (
      event,
      liveBidColumnsData,
      auctionItemDetailId
    ) => {
      const value = event.target.value;

      // Update the specific auction item in state
      handleChange(
        liveBidColumnsData,
        auctionItemDetailId,
        liveBidColumnsData.columnTypeId,
        value,
        "columnValue"
      );

      console.log(liveBidColumnsData, "liveBidColumnsData");
      console.log(auctionItemDetailId, "auctionItemDetailId");
      console.log(liveBidColumnsData.columnTypeId, "columnTypeId");

      // Store max bid for each item ID separately
      const existingMaxBids = JSON.parse(localStorage.getItem("maxBids")) || {};
      existingMaxBids[auctionItemDetailId] = value;
      localStorage.setItem("maxBids", JSON.stringify(existingMaxBids));
    };

    const maxBids = JSON.parse(localStorage.getItem("maxBids")) || {};

    return (
      <>
        {true == isTimeAvailable &&
        false == auctionDataLiveBidDetailsData.isActive &&
        (2 == activeTab || 3 == activeTab) ? (
          ""
        ) : (
          <tr
          // onClick={() =>
          //   handleSelectRow(auctionDataLiveBidDetailsData.auctionItemDetailId)
          // }
          >
            {auctionDataLiveBidDetailsData.columnDetails &&
              auctionDataLiveBidDetailsData.columnDetails.map(
                (liveBidColumnsData, liveBidColumnsIndex) => (
                  <>
                    {42 == liveBidColumnsData.columnTypeId ? (
                      <td
                        key={liveBidColumnsIndex}
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                      >
                        <input
                          type="number"
                          value={
                            maxBids[
                              auctionDataLiveBidDetailsData.auctionItemDetailId
                            ]
                              ? maxBids[
                                  auctionDataLiveBidDetailsData
                                    .auctionItemDetailId
                                ]
                              : liveBidColumnsData.columnValue
                              ? liveBidColumnsData.columnValue
                              : ""
                          }
                          onChange={(event) =>
                            handleInputChange(
                              event,
                              liveBidColumnsData,
                              auctionDataLiveBidDetailsData.auctionItemDetailId
                            )
                          }
                          disabled={
                            1 ==
                            auctionDataLiveBidDetailsData.parentChildButtonShow
                              ? 1 == userCurrentStatus
                                ? true == isHoldAuctionCalled
                                  ? true
                                  : 2 == auctionDataLiveBidDetailsData.cstatus
                                  ? true
                                  : maxBidGreaterThanBasePrice
                                  ? false
                                  : true == isPeachColorAndBidderNotIn
                                  ? false
                                  : 0 ==
                                      auctionDataLiveBidDetailsData.isItemSelected &&
                                    0 ==
                                      auctionDataLiveBidDetailsData.isActive &&
                                    ("pending-lots-color1" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                      "pending-lots-color" ==
                                        auctionDataLiveBidDetailsData.itemColor)
                                  ? false
                                  : 1 ==
                                      auctionDataLiveBidDetailsData.isItemSelected &&
                                    "unsold-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "sold-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "out-button-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "winner-buyer-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "active-lots-reached-max-bid-color" !=
                                      auctionDataLiveBidDetailsData.itemColor
                                  ? false
                                  : true
                                : true
                              : true
                          }
                          className={
                            1 ==
                            auctionDataLiveBidDetailsData.parentChildButtonShow
                              ? 1 == userCurrentStatus
                                ? true == isHoldAuctionCalled
                                  ? "liveAuctionInput form-control disabled"
                                  : 2 == auctionDataLiveBidDetailsData.cstatus
                                  ? "liveAuctionInput form-control disabled"
                                  : maxBidGreaterThanBasePrice
                                  ? "liveAuctionInput form-control"
                                  : true == isPeachColorAndBidderNotIn
                                  ? "liveAuctionInput form-control"
                                  : 0 ==
                                      auctionDataLiveBidDetailsData.isItemSelected &&
                                    0 ==
                                      auctionDataLiveBidDetailsData.isActive &&
                                    ("pending-lots-color1" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                      "pending-lots-color" ==
                                        auctionDataLiveBidDetailsData.itemColor)
                                  ? "liveAuctionInput form-control"
                                  : 1 ==
                                      auctionDataLiveBidDetailsData.isItemSelected &&
                                    "unsold-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "sold-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "out-button-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "winner-buyer-lots-color" !=
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    "active-lots-reached-max-bid-color" !=
                                      auctionDataLiveBidDetailsData.itemColor
                                  ? "liveAuctionInput form-control"
                                  : "liveAuctionInput form-control disabled"
                                : "liveAuctionInput form-control disabled"
                              : "liveAuctionInput form-control disabled"
                          }
                        />
                      </td>
                    ) : 43 == liveBidColumnsData.columnTypeId ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        key={liveBidColumnsIndex}
                      >
                        <button
                          onClick={() =>
                            handleButton(
                              "confirm",
                              auctionDataLiveBidDetailsData
                            )
                          }
                          disabled={
                            1 == userCurrentStatus
                              ? true == isHoldAuctionCalled
                                ? true
                                : 2 == auctionDataLiveBidDetailsData.cstatus
                                ? true
                                : 1 ==
                                    auctionDataLiveBidDetailsData.isItemSelected &&
                                  "unsold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "sold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "out-button-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "winner-buyer-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "active-lots-reached-max-bid-color" !=
                                    auctionDataLiveBidDetailsData.itemColor
                                ? false
                                : true
                              : true
                          }
                          className={
                            1 == userCurrentStatus
                              ? true == isHoldAuctionCalled
                                ? "liveAuctionConfirmButton disabled"
                                : 2 == auctionDataLiveBidDetailsData.cstatus
                                ? "liveAuctionConfirmButton disabled"
                                : 1 ==
                                    auctionDataLiveBidDetailsData.isItemSelected &&
                                  "unsold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "sold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "out-button-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "winner-buyer-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "active-lots-reached-max-bid-color" !=
                                    auctionDataLiveBidDetailsData.itemColor
                                ? "liveAuctionConfirmButton"
                                : "liveAuctionConfirmButton disabled"
                              : "liveAuctionConfirmButton disabled"
                          }
                        >
                          {/* CONFIRM */}
                          CLICK
                        </button>
                      </td>
                    ) : 44 == liveBidColumnsData.columnTypeId ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        key={liveBidColumnsIndex}
                      >
                        <button
                          onClick={() =>
                            handleButton("in", auctionDataLiveBidDetailsData)
                          }
                          disabled={
                            1 ==
                            auctionDataLiveBidDetailsData.parentChildButtonShow
                              ? 1 == userCurrentStatus
                                ? true == isHoldAuctionCalled
                                  ? true
                                  : 2 == auctionDataLiveBidDetailsData.cstatus
                                  ? true
                                  : true == isPeachColorAndBidderNotIn
                                  ? false
                                  : maxBidGreaterThanBasePrice
                                  ? false
                                  : "pending-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    0 ==
                                      auctionDataLiveBidDetailsData.isItemSelected
                                  ? false
                                  : "sold-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                    "unsold-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                    "active-lots-reached-max-bid-color" ==
                                      auctionDataLiveBidDetailsData.itemColor
                                  ? true
                                  : true
                                : true
                              : true
                          }
                          className={
                            1 ==
                            auctionDataLiveBidDetailsData.parentChildButtonShow
                              ? 1 == userCurrentStatus
                                ? true == isHoldAuctionCalled
                                  ? "liveAuctionInButton disabled"
                                  : 2 == auctionDataLiveBidDetailsData.cstatus
                                  ? "liveAuctionInButton disabled"
                                  : true == isPeachColorAndBidderNotIn
                                  ? "liveAuctionInButton"
                                  : maxBidGreaterThanBasePrice
                                  ? "liveAuctionInButton"
                                  : "pending-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor &&
                                    0 ==
                                      auctionDataLiveBidDetailsData.isItemSelected
                                  ? "liveAuctionInButton"
                                  : "sold-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                    "unsold-lots-color" ==
                                      auctionDataLiveBidDetailsData.itemColor ||
                                    "active-lots-reached-max-bid-color" ==
                                      auctionDataLiveBidDetailsData.itemColor
                                  ? "liveAuctionInButton disabled"
                                  : "liveAuctionInButton disabled"
                                : "liveAuctionInButton disabled"
                              : "liveAuctionInButton disabled"
                          }
                        >
                          IN
                        </button>
                      </td>
                    ) : 45 == liveBidColumnsData.columnTypeId ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        key={liveBidColumnsIndex}
                      >
                        <button
                          onClick={() =>
                            handleButton("out", auctionDataLiveBidDetailsData)
                          }
                          disabled={
                            1 == userCurrentStatus
                              ? true == isHoldAuctionCalled
                                ? true
                                : 2 == auctionDataLiveBidDetailsData.cstatus
                                ? true
                                : 1 ==
                                    auctionDataLiveBidDetailsData.isItemSelected &&
                                  "unsold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "sold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "out-button-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "winner-buyer-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "active-lots-reached-max-bid-color" !=
                                    auctionDataLiveBidDetailsData.itemColor
                                ? false
                                : true
                              : true
                          }
                          className={
                            1 == userCurrentStatus
                              ? true == isHoldAuctionCalled
                                ? "liveAuctionOutButton disabled"
                                : 2 == auctionDataLiveBidDetailsData.cstatus
                                ? "liveAuctionOutButton disabled"
                                : 1 ==
                                    auctionDataLiveBidDetailsData.isItemSelected &&
                                  "unsold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "sold-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "out-button-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "winner-buyer-lots-color" !=
                                    auctionDataLiveBidDetailsData.itemColor &&
                                  "active-lots-reached-max-bid-color" !=
                                    auctionDataLiveBidDetailsData.itemColor
                                ? "liveAuctionOutButton"
                                : "liveAuctionOutButton disabled"
                              : "liveAuctionOutButton disabled"
                          }
                        >
                          OUT
                        </button>
                      </td>
                    ) : 35 == liveBidColumnsData.columnTypeId &&
                      "winner-buyer-lots-color" !=
                        auctionDataLiveBidDetailsData.itemColor ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        onClick={() =>
                          handleSelectRow(
                            auctionDataLiveBidDetailsData.auctionItemDetailId
                          )
                        }
                        key={liveBidColumnsIndex}
                      >
                        {liveBidColumnsData.columnValue}
                      </td>
                    ) : 6 == liveBidColumnsData.columnTypeId ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        onClick={() =>
                          handleSelectRow(
                            auctionDataLiveBidDetailsData.auctionItemDetailId
                          )
                        }
                        key={liveBidColumnsIndex}
                      >
                        {true == isTimeAvailable
                          ? liveBidColumnsData.columnValue
                          : "active-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor ||
                            "active-lots-reached-max-bid-color" ==
                              auctionDataLiveBidDetailsData.itemColor ||
                            "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor ||
                            "out-button-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                          ? "Active"
                          : liveBidColumnsData.columnValue}
                      </td>
                    ) : 11 == liveBidColumnsData.columnTypeId &&
                      "unsold-lots-color" ==
                        auctionDataLiveBidDetailsData.itemColor ? (
                      <td
                        className={
                          selectedRowAvailable
                            ? "selectedRowColor"
                            : true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        key={liveBidColumnsIndex}
                      >
                        -
                      </td>
                    ) : 11 == liveBidColumnsData.columnTypeId &&
                      "winner-buyer-lots-color" ==
                        auctionDataLiveBidDetailsData.itemColor ? (
                      <td
                        className={"winner-buyer-lots-color"}
                        key={liveBidColumnsIndex}
                      >
                        {liveBidColumnsData.columnValue}
                      </td>
                    ) : 50 == liveBidColumnsData.columnTypeId &&
                      1 == userCurrentStatus ? (
                      <td
                        className={
                          true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        onClick={() =>
                          handleSelectRow(
                            auctionDataLiveBidDetailsData.auctionItemDetailId
                          )
                        }
                      >
                        <button
                          onClick={() =>
                            handleButton(
                              "removeFromMyCatalogAuctionBid",
                              auctionDataLiveBidDetailsData
                            )
                          }
                          className={"liveAuctionOutButton"}
                        >
                          Remove
                        </button>
                      </td>
                    ) : 50 == liveBidColumnsData.columnTypeId &&
                      1 != userCurrentStatus ? (
                      <></>
                    ) : (
                      <td
                        className={
                          selectedRowAvailable
                            ? "selectedRowColor"
                            : true == isTimeAvailable
                            ? "pending-lots-color1"
                            : "max-bid-reached-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "active-lots-color"
                            : "winner-buyer-lots-color" ==
                              auctionDataLiveBidDetailsData.itemColor
                            ? "sold-lots-color"
                            : auctionDataLiveBidDetailsData.itemColor
                        }
                        onClick={() =>
                          handleSelectRow(
                            auctionDataLiveBidDetailsData.auctionItemDetailId
                          )
                        }
                        key={liveBidColumnsIndex}
                      >
                        {liveBidColumnsData.columnValue}
                      </td>
                    )}
                  </>
                )
              )}
          </tr>
        )}
      </>
    );
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };

  // Function to handle drop
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = parseInt(e.dataTransfer.getData("index"));

    columns &&
      columns.map((row, index) =>
        dragIndex > dropIndex ? console.log(row.sortOrder) : "false"
      );

    if (!isNaN(dragIndex)) {
      const newColumns = [...columns];
      const draggedColumn = newColumns[dragIndex];
      newColumns.splice(dragIndex, 1);
      newColumns.splice(dropIndex, 0, draggedColumn);
      setColumns(newColumns);

      //New
      const newColumns1 = [...columns];
      newColumns1.splice(dragIndex, 1);

      // Insert the dragged column at the new index
      newColumns1.splice(dropIndex, 0, draggedColumn);

      // Update the sortOrder of the columns
      newColumns1.forEach((column, index) => {
        column.sortOrder = index + 1;
      });

      newColumns1.map((column) => console.log(column.sortOrder));

      //new end
      let dragdata;
      auctionDataLiveBidDetails &&
        auctionDataLiveBidDetails.map(
          (row, index) => (
            (dragdata = row.columnDetails[dragIndex]),
            row.columnDetails.splice(dragIndex, 1),
            row.columnDetails.splice(dropIndex, 0, dragdata)
          )
        );

      //For API Call
      let payloadData = {
        userLoginId: auctionUserId,
        auctionDetailId: auctionDetailId,
        userAuctionLoginId: auctionUserId,
        catalogColumnConfigurationDetails: newColumns1,
        type: activeTab,
      };

      dispatch(catelogSubmitData(payloadData));
    }
  };

  // Function to handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div className="tab-content">
      <div
        className="tab-pane fade show active"
        id="liveBidTab"
        role="tabpanel"
        aria-labelledby="liveBidTab"
      >
        <div className="table-responsive">
          <table
            id="example"
            className="table table-striped table-bordered table-hover"
            style={{ width: "100%" }}
          >
            <thead>
              <tr>
                {columns &&
                  columns.map(
                    (columnData, columnIndex) =>
                      // 1 == columnData.isLocked ? (
                      //   <th key={columnIndex}>{columnData.columnName}</th>
                      // ) : (
                      50 == columnData.columnTypeId &&
                      1 != userCurrentStatus ? (
                        <></>
                      ) : (
                        <th
                          key={columnIndex}
                          draggable
                          onDragStart={(e) => handleDragStart(e, columnIndex)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, columnIndex)}
                        >
                          {columnData.columnName}
                        </th>
                      )
                    // )
                  )}

                {/* {4 == activeTab &&
                "BUYER" == atob(sessionStorage.getItem("argument6")) &&
                1 == userCurrentStatus ? (
                  <th key="">Remove</th>
                ) : (
                  ""
                )} */}
              </tr>
            </thead>
            <tbody>
              {auctionDataLiveBidDetails &&
                auctionDataLiveBidDetails.map((liveBidDetailsData) =>
                  getRows(liveBidDetailsData)
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AuctionTable;
